<template>
  <main class="bridge">
    <h1>Connexion TUT’TOP</h1>
    <p>{{ message }}</p>
  </main>
</template>

<script>
import axios from 'axios'

export default {
  name: 'GoogleClassroomAccountLinkBridge',
  data() {
    return { message: 'Vérification de votre session…' }
  },
  async mounted() {
    let accessToken = null
    try {
      accessToken = localStorage.getItem('accessToken')
    } catch (error) {
      accessToken = null
    }
    if (!accessToken) {
      this.message = 'Aucune session TUT’TOP trouvée. Connectez-vous comme professeur, puis réessayez.'
      if (window.opener) {
        window.opener.postMessage({
          type: 'TUTTOP_ACCOUNT_LINK_ERROR',
          error: this.message,
        }, window.location.origin)
      }
      return
    }
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL || '/api'}/google-classroom/account-link/code`,
        {},
        { headers: { Authorization: `Bearer ${accessToken}` } },
      )
      if (window.opener) {
        window.opener.postMessage({
          type: 'TUTTOP_ACCOUNT_LINK',
          linkCode: response.data.linkCode,
          account: response.data.account,
        }, window.location.origin)
        this.message = 'Compte professeur confirmé. Cette fenêtre va se fermer.'
        window.setTimeout(() => window.close(), 250)
      }
    } catch (error) {
      this.message = error.response?.data?.error || 'Le compte connecté n’est pas un compte professeur.'
      if (window.opener) {
        window.opener.postMessage({
          type: 'TUTTOP_ACCOUNT_LINK_ERROR',
          error: this.message,
        }, window.location.origin)
      }
    }
  },
}
</script>

<style scoped>
.bridge {
  min-height: 100vh;
  display: grid;
  place-items: center;
  align-content: center;
  padding: 24px;
  text-align: center;
  font-family: Inter, Arial, sans-serif;
}
</style>
